import { ErrorMessage } from "@hookform/error-message"
import { useFormContext } from "react-hook-form"
import InputGroup from "../../../../common/form/inputGroup"
import Label from "../../../../common/form/label"
import Checkmark from "../../../../common/icons/checkmark"

const options = [
  {
    label: "Förskola",
    labelShort: "Förskola",
    value: 1,
    defaultChecked: false
  },
  {
    label: "Åk F-3",
    labelShort: "F-3",
    value: 2,
    defaultChecked: false
  },
  {
    label: "Åk 4-6",
    labelShort: "4-6",
    value: 3,
    defaultChecked: false
  },
  {
    label: "Åk 7-9",
    labelShort: "7-9",
    value: 4,
    defaultChecked: false
  },
  {
    label: "Fritids",
    labelShort: "Fritids",
    value: 5,
    defaultChecked: false
  }
]

export function GradeLabel({ grade }) {
  const subjects =
    grade
      .map((grade) => {
        return options.find((option) => option.value == grade)?.labelShort
      })
      .join(", ") || "Ingen årskurs vald"
  return <>{subjects}</>
}

export function Grade() {
  const {
    watch,
    register,
    formState: { errors }
  } = useFormContext()

  const checked = watch("grade") || []

  return (
    <InputGroup>
      <Label name="grade" required={true}>
        Årskurs
      </Label>
      <div className="flex flex-wrap gap-4">
        {options.map((option, index) => (
          <div key={index} className="relative pl-8">
            <input
              className="cursor-pointer h-6 w-6 absolute top-0.5 left-0 appearance-none rounded-[4px] border border-solid border-black-100/20 before:pointer-events-none before:absolute before:h-6 before:w-6 before:scale-0 before:rounded-[4px] before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-summer-green-100 checked:bg-summer-green-100"
              type="checkbox"
              id={`grade-${index}`}
              value={option.value}
              defaultChecked={option.defaultChecked}
              {...register("grade", {
                required: {
                  value: true,
                  message: "Detta fält är obligatoriskt"
                }
              })}
            />
            <label
              className="cursor-pointer text-base whitespace-nowrap"
              htmlFor={`grade-${index}`}>
              {checked.includes(option.value.toString()) && (
                <Checkmark className="w-4 absolute top-1.5 left-1" />
              )}
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <ErrorMessage
        errors={errors}
        name="grade"
        render={({ message }) => (
          <p className="text-red-100 text-sm mt-2">{message}</p>
        )}
      />
    </InputGroup>
  )
}
